import './Clientes.css';
import logoDpworld from '../assets/images/logo-dpworld.png';
import logoLip from '../assets/images/logo-lip.png';
import logoSagitario from '../assets/images/logo-sagitario.png';
import logoAntares from '../assets/images/logo-antares.webp';
import logoTaipa from '../assets/images/logo-talpa.png';
import logoAceros from '../assets/images/logo-aceros.png';
import logoInka from '../assets/images/logo-inka.png';
import logoPuertoParacas from '../assets/images/logo-puertoparacas.png';
import logoApm from '../assets/images/logo-apm.png';
import logoDpworldCallao from '../assets/images/logo-dpworldcallao.png';

const clientes = [
  { nombre: 'DP World', logo: logoDpworld },
  { nombre: 'LIP', logo: logoLip },
  { nombre: 'Gruas Sagitario', logo: logoSagitario },
  { nombre: 'Antares Logistics', logo: logoAntares },
  { nombre: 'Taipa S.A.C.', logo: logoTaipa },
  { nombre: 'Aceros Arequipa', logo: logoAceros },
  { nombre: 'Inka', logo: logoInka },
];

const permisos = [
  { nombre: 'Puerto Paracas', logo: logoPuertoParacas },
  { nombre: 'APM Terminals Callao', logo: logoApm },
  { nombre: 'DP World Callao', logo: logoDpworldCallao },
];

export default function Clientes() {
  return (
    <section id="clientes" className="clientes">
      <div className="container">
        <h2 className="section-title">Clientes que confían en nosotros</h2>
        <div className="section-divider" />

        <div className="clientes__grid">
          {clientes.map((c) => (
            <div key={c.nombre} className="clientes__badge">
              <img src={c.logo} alt={c.nombre} className="clientes__logo" />
            </div>
          ))}
        </div>

        <div className="permisos">
          <h3 className="permisos__titulo">Permisos habilitados para operar en:</h3>
          <div className="permisos__grid">
            {permisos.map((p) => (
              <div key={p.nombre} className="permisos__item">
                <img src={p.logo} alt={p.nombre} className="permisos__logo" />
                <span className="permisos__nombre">{p.nombre}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
